/**
 * Created by lu on 2017/9/28.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        _checkInputEmpty: function (inModel, inErrorMsg) {  //验证非空    如果是空，弹提示
            var value = inModel.get('value');
            inErrorMsg = inErrorMsg ? inErrorMsg : '请输入用户名';
            if (!value || value.trim().length == 0) {
                this._setErrorInfo(inModel, inErrorMsg);
                return true;
            }
            this._clearErrorInfo(inModel);
        },
        _checkIsMobile: function (inModel) {      //验证手机号字段
            var value = inModel.get('value') || '';
            var reg = /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
            if (this._checkInputEmpty(inModel, '请输入您的手机号！')) {
                return true;
            }
            if (reg.test(value)) {
                this._clearErrorInfo(inModel);
                return false;
            } else {
                this._setErrorInfo(inModel, '请输入有效手机号码！');
                return true;
            }
        },
        _checkEmail: function (inModel) {     //验证邮箱
            var value = inModel.get('value');
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (this._checkInputEmpty(inModel, '请填写邮箱！')) {
                return true;
            }
            if (reg.test(value)) {
                this._clearErrorInfo(inModel);
                return false
            } else {
                this._setErrorInfo(inModel, '请输入有效的邮箱！');
                return true
            }
        },
        _checkIsEmailAndMobile: function (inModel) {
            var value = inModel.get('value') || '';
            var mobileReg = /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
            var emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (this._checkInputEmpty(inModel, '请输入您的手机号或邮箱！')) {
                return true;
            }
            if (mobileReg.test(value) || emailReg.test(value)) {
                this._clearErrorInfo(inModel);
                return false
            } else {
                this._setErrorInfo(inModel, '请输入有效的手机号或邮箱！');
                return true
            }
        },
        _checkIdNumber: function (inModel) {      //验证身份证号
            var value = inModel.get('value') || '';
            var reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
            if (this._checkInputEmpty(inModel, '请输入您的的身份证号码！')) {
                return true;
            }
            if (reg.test(value)) {
                this._clearErrorInfo(inModel);
                return false;
            } else {
                this._setErrorInfo(inModel, '请输入正确的身份证号码！');
                return true;
            }
        },
        _checkPassword: function (inModel) {   //验证密码规定字符
            var value = inModel.get('value');
            var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
            if (this._checkInputEmpty(inModel, '请输入密码！')) {
                return true;
            }
            if (reg.test(value)) {
                this._clearErrorInfo(inModel);
                return false
            } else {
                this._setErrorInfo(inModel, '密码必须为6-21个字符，同时包含数字和字母！');
                return true
            }
        },

        _confirmPassword: function (inPassword, inPassword2) {  //验证第二此确定密码
            this._checkPassword(inPassword2);
            var value1 = inPassword.get('value') || '';
            var value2 = inPassword2.get('value') || '';
            if (value1 != value2 || value2 == "") {
                this._setErrorInfo(inPassword2, '两次密码输入不一致,请重新输入');
                return true;
            }
            this._clearErrorInfo(inPassword2);
        },
        _setErrorInfo: function (inModel, inErrorInfo) {
            // inModel.set('focus', true, {skipSameValue: false});
            // inModel.set('value', '');
            inModel.set('status', 'error');
            inModel.set('errorMsg', inErrorInfo);
        },
        _clearErrorInfo: function (inModel) {
            inModel.set('status', '');
            inModel.set('errorMsg', '');
        },
        _clearText: function (inModel) {
            inModel.set('value', '');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/form/Input.js
// module id = 31
// module chunks = 0 1 2 3 4 6 9 10 12 13 17 18 21 24 32 35 36